import React from 'react';
import { Book, Check } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    title: 'TOMO 1',
    subtitle: 'Infantiles A1 (6-8 años)',
    desc: 'El primer contacto con el italiano. Colores, familia, animales y saludos con actividades visuales 100% lúdicas.'
  }, {
    title: 'TOMO 2',
    subtitle: 'Infantiles A1 (9-12 años)',
    desc: 'Más autonomía, más escritura. Rutina diaria, cocina italiana, verbos ESSERE / AVERE / FARE en contexto.'
  }, {
    title: 'TOMO 3',
    subtitle: 'Adolescentes A1',
    desc: 'El italiano desde cero para jóvenes. Presentación, escuela, tecnología y cultura italiana adaptada al aula argentina.'
  }, {
    title: 'TOMO 4',
    subtitle: 'Adolescentes A2',
    desc: 'Consolidación del nivel A2 con adolescentes. Pasado, futuro, descripción y narración en situaciones reales.'
  }, {
    title: 'TOMO 5',
    subtitle: 'Adolescentes B1',
    desc: 'Comunicación real en italiano. Opinión, medios, sociedad y primeras estructuras complejas.'
  }, {
    title: 'TOMO 6',
    subtitle: 'Adolescentes B2',
    desc: '"Penso, Quindi Parlo." Pensamiento crítico, textos auténticos y producción académica inicial.'
  }, {
    title: 'TOMO 7',
    subtitle: 'Adolescentes C1',
    desc: 'Dominio avanzado para jóvenes. Argumentación, análisis literario y producción formal de alto nivel.'
  }, {
    title: 'TOMO 8',
    subtitle: 'Adultos Inicial A1-A2',
    desc: 'El sistema completo para adultos que arrancan desde cero. Plug & play desde la clase 1.'
  }, {
    title: 'TOMO 9',
    subtitle: 'Adultos Intermedio B1-B2',
    desc: 'Para adultos que ya saben lo básico pero necesitan dar el salto. Estructuras avanzadas en contexto real.'
  }, {
    title: 'TOMO 10',
    subtitle: 'Adultos Avanzado C1-C2',
    desc: 'El italiano de los que casi ya dominan el idioma. Ensayos, debates y producción de nivel universitario.'
  }, {
    title: 'TOMO 11',
    subtitle: 'Especial — Fonética Avanzada + Ensayos',
    desc: 'Las consonantes doppie, la prosodia y la escritura académica formal. Para alumnos que quieren sonar italianos.'
  }, {
    title: 'TOMO 12',
    subtitle: 'Especial — Simulacros PLIDA + Portfolio',
    desc: 'Preparación completa para el examen PLIDA B1, B2, C1 y C2. Con rúbricas y portfolio de cierre de nivel.'
  }];
  return <section className="py-20 bg-white" data-id="element-313">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-314">
        <div className="text-center mb-16" data-id="element-315">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1F1A17] mb-4" data-id="element-316">
            Los 12 Tomos Completos
          </h2>
          <p className="text-xl text-gray-600" data-id="element-317">
            Ejercicios graficados · Por nivel y edad · Listo para usar mañana
          </p>
          <div className="w-24 h-1 bg-brand-green mx-auto mt-8" data-id="element-318"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-319">
          {tomos.map((tomo, i) => <div key={i} className="bg-[#FAF7F2] p-8 rounded-2xl border border-gray-200 hover:border-brand-green transition-colors duration-300" data-id="element-320">
              <div className="flex items-center mb-4" data-id="element-321">
                <Book className="w-6 h-6 text-brand-green mr-3" data-id="element-322" />
                <h3 className="text-xl font-bold text-[#1A1A1A]" data-id="element-323">
                  {tomo.title}
                </h3>
              </div>
              <h4 className="text-lg font-serif font-bold text-gray-800 mb-3" data-id="element-324">
                {tomo.subtitle}
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-325">{tomo.desc}</p>
            </div>)}
        </div>

        <div className="bg-[#2B211A] rounded-2xl p-8 md:p-12 text-white" data-id="element-326">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-327">
            {['✏️ Ejercicios graficados en cada tomo', '⚡ Sistema "Abrí y Dictás"', '📋 Fichas listas para imprimir o proyectar', '🇦🇷 Contenido 100% adaptado a Argentina'].map((feature, i) => <div key={i} className="flex items-center text-lg font-medium" data-id="element-328">
                {feature}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}